import client from './client';

export const listTenants = () =>
  client.get('/api/admin/tenants').then(r => r.data);

export const updateTenant = (id, body) =>
  client.patch(`/api/admin/tenants/${id}`, body).then(r => r.data);

export const purgeTenant = (id) =>
  client.delete(`/api/admin/tenants/${id}?confirm=PURGE_TENANT_${id}`).then(r => r.data);

export const resetUserPassword = (userId, password) =>
  client.post(`/api/admin/users/${userId}/reset-password`, { password }).then(r => r.data);
